"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initApprove = exports.isBuyOrderHandle = exports.isSellOrderHandle = void 0;
var config_1 = require("../config");
var types_1 = require("../utils/types");
var isSellOrderHandle = function (orderType) {
    return orderType === types_1.MakeOrderType.FixPriceOrder ||
        orderType === types_1.MakeOrderType.DutchAuctionOrder ||
        orderType === types_1.MakeOrderType.EnglishAuctionOrder;
};
exports.isSellOrderHandle = isSellOrderHandle;
var isBuyOrderHandle = function (orderType) {
    return orderType === types_1.MakeOrderType.MakeOfferOrder || orderType === types_1.MakeOrderType.EnglishAuctionBiddingOrder;
};
exports.isBuyOrderHandle = isBuyOrderHandle;
var initApprove = function (_a) {
    var APENFTOrders = _a.APENFTOrders, orderType = _a.orderType, orderParams = _a.orderParams;
    return __awaiter(void 0, void 0, void 0, function () {
        var isSellOrder, isBuyOrder, isAPENFTAsset, isAcceptTRX, res, app, app, res, app;
        var _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    isSellOrder = (0, exports.isSellOrderHandle)(orderType);
                    isBuyOrder = (0, exports.isBuyOrderHandle)(orderType);
                    isAPENFTAsset = APENFTOrders.account.APENFTSharedAssetAddr === orderParams.asset.tokenAddress;
                    isAcceptTRX = ((_b = orderParams === null || orderParams === void 0 ? void 0 : orderParams.paymentToken) === null || _b === void 0 ? void 0 : _b.address) === "" ||
                        ((_c = orderParams === null || orderParams === void 0 ? void 0 : orderParams.paymentToken) === null || _c === void 0 ? void 0 : _c.address) === undefined ||
                        ((_d = orderParams === null || orderParams === void 0 ? void 0 : orderParams.paymentToken) === null || _d === void 0 ? void 0 : _d.address) === config_1.NULL_ADDRESS;
                    if (!isSellOrder) return [3 /*break*/, 7];
                    return [4 /*yield*/, APENFTOrders.account.getOrderApproveStep(orderParams, 1, orderParams === null || orderParams === void 0 ? void 0 : orderParams.startAmount)];
                case 1:
                    res = _k.sent();
                    if (!("paymentTokenApprove" in res && !isAcceptTRX)) return [3 /*break*/, 4];
                    if (!res.paymentTokenApprove.isApprove) return [3 /*break*/, 2];
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, ((_e = res.paymentTokenApprove) === null || _e === void 0 ? void 0 : _e.func.call(APENFTOrders === null || APENFTOrders === void 0 ? void 0 : APENFTOrders.account, (_f = orderParams === null || orderParams === void 0 ? void 0 : orderParams.paymentToken) === null || _f === void 0 ? void 0 : _f.address))];
                case 3:
                    app = _k.sent();
                    console.log("paymentTokenApprove app");
                    console.log(app);
                    _k.label = 4;
                case 4:
                    if (!("sellAssetApprove" in res && !isAPENFTAsset)) return [3 /*break*/, 7];
                    if (!res.sellAssetApprove.isApprove) return [3 /*break*/, 5];
                    return [3 /*break*/, 7];
                case 5: return [4 /*yield*/, ((_g = res.sellAssetApprove) === null || _g === void 0 ? void 0 : _g.func.call(APENFTOrders.account, res === null || res === void 0 ? void 0 : res.metadata))];
                case 6:
                    app = _k.sent();
                    console.log("sellAssetApprove app");
                    console.log(app);
                    _k.label = 7;
                case 7:
                    if (!isBuyOrder) return [3 /*break*/, 11];
                    return [4 /*yield*/, APENFTOrders.account.getOrderApproveStep(orderParams, 0, orderParams === null || orderParams === void 0 ? void 0 : orderParams.startAmount)];
                case 8:
                    res = _k.sent();
                    if (!("paymentTokenApprove" in res && !isAcceptTRX)) return [3 /*break*/, 11];
                    if (!res.paymentTokenApprove.isApprove) return [3 /*break*/, 9];
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, ((_h = res.paymentTokenApprove) === null || _h === void 0 ? void 0 : _h.func.call(APENFTOrders === null || APENFTOrders === void 0 ? void 0 : APENFTOrders.account, (_j = orderParams === null || orderParams === void 0 ? void 0 : orderParams.paymentToken) === null || _j === void 0 ? void 0 : _j.address))];
                case 10:
                    app = _k.sent();
                    console.log("paymentTokenApprove app");
                    console.log(app);
                    _k.label = 11;
                case 11: return [2 /*return*/, true];
            }
        });
    });
};
exports.initApprove = initApprove;
